import { Injectable } from '@angular/core';
import { hasValue, isDefined, isFunction, isString } from '@app/util';
import { TranslateParser } from '@ngx-translate/core';

@Injectable()
export class PcsTranslateParser extends TranslateParser {
  private readonly templateMatcher: RegExp = /{\s?([^{}\s]*)\s?}/g;

  /**
   * Interpolates a string to replace parameters
   * "This is a {key}" ==> "This is a value", with params = { key: "value" }
   * @param expr
   * @param params
   */
  interpolate(expr: string | Function, params?: any): string {
    if (isString(expr)) {
      return this.interpolateString(expr, params);
    } else if (isFunction(expr)) {
      return expr(params);
    }
    return expr;
  }

  /**
   * Returns a value from an object by key
   * parser.getValue({ key: 'value' }, 'key') ==> 'value'
   * @param messages
   * @param key
   */
  getValue(messages: any, key: string): string {
    if (isDefined(messages)) {
      return messages[key] || key;
    }
    return key;
  }

  private interpolateString(expr: string, params?: any) {
    if (!params) {
      return expr;
    }

    return expr.replace(this.templateMatcher, (match: string, key: string) => {
      const replacement = this.getParameter(params, key);
      return isDefined(replacement) ? replacement : match;
    });
  }

  private getParameter(params: any, key: string): string {
    if (hasValue(params)) {
      return params[key];
    }
    return key;
  }
}
